import {
  Eye,
  HelpCircle,
  Mail,
  MailOpen,
  MessageCircle,
  MousePointerClick,
  Send,
  User,
} from "lucide-react";
import { CHANNEL_COLORS } from "@/lib/constants/channels";
import type { StatusConfig } from "./types";

// Re-export the channel colors from the shared location
export const channelColors = CHANNEL_COLORS;

export const statusConfig: Record<string, StatusConfig> = {
  opened: {
    icon: MailOpen,
    color: "text-supporting-green",
    label: "Opened",
  },
  delivered: {
    icon: Mail,
    color: "text-muted-foreground",
    label: "Delivered",
  },
  clicked: {
    icon: MousePointerClick,
    color: "text-supporting-blue",
    label: "Clicked",
  },
  viewed: {
    icon: Eye,
    color: "text-supporting-purple",
    label: "Viewed",
  },
  member: {
    icon: User,
    color: "text-muted-foreground",
    label: "Member",
  },
  sent: {
    icon: Send,
    color: "text-supporting-yellow",
    label: "Sent",
  },
  conversation: {
    icon: MessageCircle,
    color: "text-supporting-blue",
    label: "Conversation",
  },
  unknown: {
    icon: HelpCircle,
    color: "text-muted-foreground",
    label: "Unknown",
  },
};

// Cache for formatted status strings
export const statusFormattingCache = new Map<string, string>();

export const MIN_DAYS_FOR_GAP = 3;
